import React from 'react';
import classnames from 'classnames';
import Icon from 'common/mdc/icon';

const QuickSearch = ({ className, ...props }) => (
  <div
    className={classnames(
      'search',
      className,
    )}
  >
    <Icon className="search-icon align-icons" aria-label="Search" alt="Search">
      search
    </Icon>
    <input
      type="text"
      {...props}
    />
  </div>
);

export default QuickSearch;
